export default __webpack_public_path__ + "static/media/flag-san-marino.231cade4.svg";